
import { Link } from 'react-router-dom';

interface Props {
  title?: string;
  description?: string;
}

export default function AcquirerGate({
  title = 'Agrega un adquirente para ver tus cuotas',
  description = 'Para ver tus cuotas disponibles, primero debes agregar al menos un adquirente en la configuración de tu cuenta.',
}: Props = {}) {
  return (
    <div className="bg-white dark:bg-slate-900 border-2 border-blue-100 dark:border-blue-900/30 rounded-xl shadow-xl p-8">
      <div className="flex flex-col items-center text-center max-w-md mx-auto py-8">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-50 dark:bg-blue-900/20 text-primary mb-6">
          <span className="material-symbols-outlined text-3xl">key</span>
        </div>
        <h2 className="text-xl font-bold text-slate-900 dark:text-white leading-tight mb-3">
          {title}
        </h2>
        <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed mb-8">
          {description}
        </p>
        <Link
          to="/configuraciones/credenciales-adquirente"
          className="bg-primary hover:bg-blue-700 text-white px-6 py-3 rounded-lg text-sm font-bold shadow-lg shadow-primary/20 transition-all flex items-center gap-2"
        >
          Agregar Adquirente
          <span className="material-symbols-outlined text-sm">arrow_forward</span>
        </Link>
      </div>
    </div>
  );
}
